export class DataAccessMethodNotImplementedError extends Error {
  public readonly name: string = 'DataAccessMethodNotImplementedError';
  public readonly methodParams?: any;

  constructor(methodName: string, params?: any) {
    super(`Method "${methodName}" not implemented.`);
    this.methodParams = params;
  }
}
